import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showCaptcha", "children", "currentCtn", "data", "analyticsOnChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cloneElement, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
export var CAPTCHA_STATUS = {
  success: 'success',
  fail: 'fail'
};
var CaptchaWithCallbackPopupHOC = function CaptchaWithCallbackPopupHOC(_ref) {
  var showCaptcha = _ref.showCaptcha,
    children = _ref.children,
    currentCtn = _ref.currentCtn,
    data = _ref.data,
    analyticsOnChange = _ref.analyticsOnChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(currentCtn || ''),
    _useState2 = _slicedToArray(_useState, 2),
    phoneInputValue = _useState2[0],
    setPhoneInputValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCheckboxChecked = _useState4[0],
    setCheckboxChecked = _useState4[1];
  var _useState5 = useState(showCaptcha),
    _useState6 = _slicedToArray(_useState5, 2),
    captcha = _useState6[0],
    setCaptcha = _useState6[1];
  var _useState7 = useState(CAPTCHA_STATUS.success),
    _useState8 = _slicedToArray(_useState7, 2),
    captchaStatus = _useState8[0],
    setCaptchaStatus = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    captchaMsg = _useState10[0],
    setCaptchaMsg = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    refreshCaptcha = _useState12[0],
    setRefreshCaptcha = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    captchaToken = _useState14[0],
    setCaptchaToken = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    captchaKey = _useState16[0],
    setCaptchaKey = _useState16[1];
  var changePhone = function changePhone(value) {
    setPhoneInputValue(value);
    if (value.length === 10) analyticsOnChange === null || analyticsOnChange === void 0 || analyticsOnChange();
  };
  var changeCheckbox = function changeCheckbox(e) {
    setCheckboxChecked(e.target.checked);
  };
  var changeCaptchaState = function changeCaptchaState(value) {
    setCaptcha(value);
    setCaptchaToken('');
    setCaptchaMsg(data === null || data === void 0 ? void 0 : data.texts.captchaTexts.errorMsg);
  };
  var changeCaptchaToken = function changeCaptchaToken(value) {
    setCaptchaToken(value);
  };
  return /*#__PURE__*/cloneElement(children, _objectSpread({
    reCaptchaModel: {
      onChange: changeCaptchaToken,
      refreshCaptcha: refreshCaptcha,
      setCaptchaKey: setCaptchaKey,
      setRefreshCaptcha: setRefreshCaptcha
    },
    captchaStatus: captchaStatus,
    changeCaptchaStatus: setCaptchaStatus,
    captchaMsg: captchaMsg,
    changeCaptchaMsg: setCaptchaMsg,
    captchaKey: captchaKey,
    showCaptcha: captcha,
    captchaToken: captchaToken,
    changeCaptchaToken: setCaptchaToken,
    changeCaptchaState: changeCaptchaState,
    changePhone: changePhone,
    phoneInputValue: phoneInputValue,
    data: data,
    isCheckboxChecked: isCheckboxChecked,
    changeCheckbox: changeCheckbox
  }, rest));
};
CaptchaWithCallbackPopupHOC.propTypes = process.env.NODE_ENV !== "production" ? {
  showCaptcha: PropTypes.bool,
  activeCtn: PropTypes.string
} : {};
var ConnectedReCaptchaAndPhoneHOC = connect(function (_ref2) {
  var external = _ref2.external;
  return {
    locale: external.locale || 'ru'
  };
})(CaptchaWithCallbackPopupHOC);
export { ConnectedReCaptchaAndPhoneHOC as CaptchaWithCallbackPopupHOC };